import BalasForum from "./src/BalasForum";

export default BalasForum